import * as React from "react";

const AvailabilityLowStock: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="m 11.294814,8.1998614 c -0.134605,0 -0.241491,0.1108302 -0.23751,0.2454346 l 0.296888,7.758654 c 0.0039,0.130622 0.11083,0.229585 0.237509,0.229585 h 0.811492 c 0.12668,0 0.233529,-0.102911 0.23751,-0.229585 L 12.93759,8.445296 C 12.94149,8.3106916 12.834648,8.1998614 12.700081,8.1998614 Z m 0.704605,9.0253726 c -0.613567,0 -1.108379,0.494812 -1.108379,1.10838 0,0.613566 0.494812,1.108378 1.108379,1.108378 0.613567,0 1.108379,-0.494812 1.108379,-1.108378 0,-0.613568 -0.494812,-1.10838 -1.108379,-1.10838 z m 11.143169,2.058419 -9.49645,-16.4673474 c -0.72834,-1.2667191 -2.561116,-1.2667191 -3.293438,0 L 0.85625003,19.283653 C 0.12787113,20.546428 1.0383254,22.13377 2.5029693,22.13377 H 21.499811 c 1.45672,0 2.375099,-1.583398 1.642777,-2.850117 z m -1.642777,1.583399 H 2.4990262 c -0.4868873,0 -0.7916994,-0.526472 -0.5502465,-0.95004 L 11.449172,3.449665 c 0.241492,-0.4195852 0.855058,-0.4235668 1.096512,0 l 9.500393,16.467347 c 0.245433,0.419586 -0.05938,0.95004 -0.546266,0.95004 z" />
        </svg>
    );
};

export default React.memo(AvailabilityLowStock);
